"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CHARACTER_CONFIG = exports.RACE_COLOR_MAP = exports.MORPH_TARGET_MAP = exports.BaseCharacterPants = exports.BaseCharacterShirt = exports.BaseCharacterClothing = exports.BaseCharacterEyes = exports.BaseCharacterBeard = exports.BaseCharacterMoustache = exports.BaseCharacterHairTail = exports.BaseCharacterHairSide = exports.BaseCharacterHairFringe = exports.BaseCharacterHairBack = exports.BaseCharacterHairBase = exports.BaseCharacterGender = exports.BaseCharacterRace = exports.BaseCharacterClass = void 0;
var character_model_1 = require("./character.model");
var BaseCharacterClass;
(function (BaseCharacterClass) {
    BaseCharacterClass["Warrior"] = "warrior";
    BaseCharacterClass["Rogue"] = "rogue";
    BaseCharacterClass["Mage"] = "mage";
})(BaseCharacterClass || (exports.BaseCharacterClass = BaseCharacterClass = {}));
var BaseCharacterRace;
(function (BaseCharacterRace) {
    BaseCharacterRace["Human"] = "human";
    BaseCharacterRace["Elf"] = "elf";
    BaseCharacterRace["Orc"] = "orc";
})(BaseCharacterRace || (exports.BaseCharacterRace = BaseCharacterRace = {}));
var BaseCharacterGender;
(function (BaseCharacterGender) {
    BaseCharacterGender["Male"] = "male";
    BaseCharacterGender["Female"] = "female";
})(BaseCharacterGender || (exports.BaseCharacterGender = BaseCharacterGender = {}));
var BaseCharacterHairBase;
(function (BaseCharacterHairBase) {
    BaseCharacterHairBase["None"] = "none";
    BaseCharacterHairBase["Normal"] = "normal";
    BaseCharacterHairBase["Mohawk"] = "mohawk";
    BaseCharacterHairBase["Undercut"] = "undercut";
    BaseCharacterHairBase["Spiky"] = "spiky";
})(BaseCharacterHairBase || (exports.BaseCharacterHairBase = BaseCharacterHairBase = {}));
var BaseCharacterHairBack;
(function (BaseCharacterHairBack) {
    BaseCharacterHairBack["None"] = "none";
    BaseCharacterHairBack["Short"] = "short";
    BaseCharacterHairBack["Long"] = "long";
})(BaseCharacterHairBack || (exports.BaseCharacterHairBack = BaseCharacterHairBack = {}));
var BaseCharacterHairFringe;
(function (BaseCharacterHairFringe) {
    BaseCharacterHairFringe["None"] = "none";
    BaseCharacterHairFringe["Normal"] = "normal";
    BaseCharacterHairFringe["Straight"] = "straight";
    BaseCharacterHairFringe["MiddlePart"] = "middlePart";
    BaseCharacterHairFringe["MiddlePartThick"] = "middlePartThick";
    BaseCharacterHairFringe["StraightBangs"] = "straightBangs";
    BaseCharacterHairFringe["SidePart"] = "sidePart";
    BaseCharacterHairFringe["Curtains"] = "curtains";
    BaseCharacterHairFringe["SideStraightPart"] = "sideStraightPart";
    BaseCharacterHairFringe["FluffyBangs"] = "fluffyBangs";
})(BaseCharacterHairFringe || (exports.BaseCharacterHairFringe = BaseCharacterHairFringe = {}));
var BaseCharacterHairSide;
(function (BaseCharacterHairSide) {
    BaseCharacterHairSide["None"] = "none";
    BaseCharacterHairSide["Normal"] = "normal";
    BaseCharacterHairSide["Long"] = "long";
})(BaseCharacterHairSide || (exports.BaseCharacterHairSide = BaseCharacterHairSide = {}));
var BaseCharacterHairTail;
(function (BaseCharacterHairTail) {
    BaseCharacterHairTail["None"] = "none";
    BaseCharacterHairTail["Ponytail"] = "ponytail";
    BaseCharacterHairTail["Twin"] = "twin";
    BaseCharacterHairTail["DoubleBun"] = "doubleBun";
    BaseCharacterHairTail["Braids"] = "braids";
    BaseCharacterHairTail["BraidedPigtails"] = "braidedPigtails";
})(BaseCharacterHairTail || (exports.BaseCharacterHairTail = BaseCharacterHairTail = {}));
var BaseCharacterMoustache;
(function (BaseCharacterMoustache) {
    BaseCharacterMoustache["None"] = "none";
    BaseCharacterMoustache["Normal"] = "normal";
})(BaseCharacterMoustache || (exports.BaseCharacterMoustache = BaseCharacterMoustache = {}));
var BaseCharacterBeard;
(function (BaseCharacterBeard) {
    BaseCharacterBeard["None"] = "none";
    BaseCharacterBeard["Normal"] = "normal";
})(BaseCharacterBeard || (exports.BaseCharacterBeard = BaseCharacterBeard = {}));
var BaseCharacterEyes;
(function (BaseCharacterEyes) {
    BaseCharacterEyes["Normal"] = "normal";
    BaseCharacterEyes["Determined"] = "determined";
    BaseCharacterEyes["Curious"] = "curious";
    BaseCharacterEyes["Cool"] = "cool";
    BaseCharacterEyes["Kind"] = "kind";
    BaseCharacterEyes["Beautiful"] = "beautiful";
    BaseCharacterEyes["Sharp"] = "sharp";
    BaseCharacterEyes["Almond"] = "almond";
    BaseCharacterEyes["Fierce"] = "fierce";
    BaseCharacterEyes["Cat"] = "cat";
})(BaseCharacterEyes || (exports.BaseCharacterEyes = BaseCharacterEyes = {}));
var BaseCharacterClothing;
(function (BaseCharacterClothing) {
    BaseCharacterClothing["None"] = "none";
    BaseCharacterClothing["Normal"] = "normal";
})(BaseCharacterClothing || (exports.BaseCharacterClothing = BaseCharacterClothing = {}));
var BaseCharacterShirt;
(function (BaseCharacterShirt) {
    BaseCharacterShirt["None"] = "none";
    BaseCharacterShirt["Warrior"] = "warrior";
    BaseCharacterShirt["Assassins"] = "assassins";
    BaseCharacterShirt["Mage"] = "mage";
})(BaseCharacterShirt || (exports.BaseCharacterShirt = BaseCharacterShirt = {}));
var BaseCharacterPants;
(function (BaseCharacterPants) {
    BaseCharacterPants["None"] = "none";
    BaseCharacterPants["Assassins"] = "assassins";
})(BaseCharacterPants || (exports.BaseCharacterPants = BaseCharacterPants = {}));
/**
 * Maps the morph target to their keys
 */
exports.MORPH_TARGET_MAP = {
    neckSize: "Neck",
    armSize: "Arms",
    chestSize: "Chest",
    waistSize: "Waist",
    thighSize: "Thighs",
    calvesSize: "Calves",
    noseHeight: "NoseHeight",
    noseWidth: "NoseWidth",
    cheeks: "Cheeks",
    eyeDroop: "EyeDroop",
};
exports.RACE_COLOR_MAP = {
    human: {
        skin: [
            "#FFCC99",
            "#FEB186",
            "#DFC183",
            "#CEAB69",
            "#B98865",
            "#AA724B",
            "#935D37",
            "#CBACA3",
            "#C0A183",
            "#C18E74",
            "#EBCDA8",
            "#CAA661",
            "#7B4B2A",
            "#573719",
            "#483728",
        ],
        eyes: character_model_1.CHARACTER_EYE_COLORS,
        hair: character_model_1.CHARACTER_HAIR_COLORS,
    },
    elf: {
        skin: [
            "#DFC183",
            "#FFCC99",
            "#FEB186",
            "#E7EECF",
            "#CAD0C2",
            "#2A304f",
            "#646085",
        ],
        eyes: character_model_1.CHARACTER_EYE_COLORS,
        hair: character_model_1.CHARACTER_HAIR_COLORS,
    },
    orc: {
        skin: [
            "#6F977E",
            "#f1873b",
            "#ee9b59",
            "#233329",
            "#6A7152",
            "#5f7278",
            "#c19fa6",
        ],
        eyes: character_model_1.CHARACTER_EYE_COLORS,
        hair: character_model_1.CHARACTER_HAIR_COLORS,
    },
};
exports.DEFAULT_CHARACTER_CONFIG = {
    race: BaseCharacterRace.Human,
    gender: BaseCharacterGender.Male,
    eyes: BaseCharacterEyes.Normal,
    skinColor: "#f9d3a3",
    eyeColor: "#12335b",
    hairColor: "#506372",
    clothing: BaseCharacterClothing.Normal,
    hairBase: BaseCharacterHairBase.Normal,
    hairBack: BaseCharacterHairBack.None,
    hairFringe: BaseCharacterHairFringe.None,
    hairSide: BaseCharacterHairSide.None,
    hairTail: BaseCharacterHairTail.None,
    moustache: BaseCharacterMoustache.None,
    beard: BaseCharacterBeard.None,
    weapon: null,
    pants: BaseCharacterPants.None,
    shirt: BaseCharacterShirt.None,
    neckSize: 0,
    chestSize: 0,
    armSize: 0,
    waistSize: 0,
    thighSize: 0,
    calvesSize: 0,
    noseWidth: 0,
    noseHeight: 0,
    cheeks: 0,
    eyeDroop: 0,
    helmet: null,
};
